import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { expires, matchVideoResolver, storedMatchUrl, type StoredMatch } from '../utils/matchVideoUrl';

const resolveMatch = matchVideoResolver(async (bookingId) => (await httpsCallable<{ bookingId: string },
  { url: string }>(functions, 'getLiveMatchVideo')({ bookingId })).data.url);

/**
 * The URL a lesson's match plays from: the stored one when it lasts, else a
 * lasting one asked for on read (utils/matchVideoUrl). Null while it is asked
 * for, or when the lesson has no match.
 */
export function useMatchVideoUrl(b: StoredMatch | null | undefined): string | null {
  const stored = storedMatchUrl(b);
  const id = b?.id;
  const [resolved, setResolved] = useState<{ key: string; url: string | null } | null>(null);
  const key = `${id}|${stored}`;
  useEffect(() => {
    if (!id || !stored || !expires(stored)) return;
    let live = true;
    resolveMatch({ id, playerVideoUrl: stored }).then((url) => { if (live) setResolved({ key, url }); });
    return () => { live = false; };
  }, [id, stored, key]);
  if (!stored) return null;
  if (!expires(stored)) return stored;
  return resolved?.key === key ? resolved.url : null;
}
